import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal, ModalBody, ModalHeader} from 'react-bootstrap'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {
  API_URL,
  isMegaPay,
  isNotEmpty,
  KTIcon,
  KTSVG,
  numberWithCommas,
} from '../../../../../../../_metronic/helpers'
import axios from 'axios'
import {OnlinePulse} from '../../../../../accounts/OnlinePulse'

type props = {
  fee: {
    fee: string
    setFee: Dispatch<SetStateAction<string>>
  }
  carat: {
    carat: string
    setCarat: Dispatch<SetStateAction<string>>
  }
  popupHandle: {
    show: boolean
    hide: Dispatch<SetStateAction<boolean>>
  }
}

const GoldPriceCal: FC<props> = ({fee, popupHandle, carat: _carat}) => {
  const [price, setPrice] = useState('')
  const [carat, setCarat] = useState(_carat.carat)
  const [calculated, setCalculated] = useState('')
  const [first, setFirst] = useState(true)
  const [loadingPrice, setLoadingPrice] = useState(true)
  const [mesghalPrice, setMesghalPrice] = useState('')
  const [gram18Price, setGram18Price] = useState('')
  const [recentPrice, setRecentPrice] = useState('')
  const [_key, set_key] = useState(1)
  const [point, setPoint] = useState(4.6036)

  useEffect(() => {
    if (first) {
      setFirst(false)
      getPrice()
      let priceIntervalId = setInterval(() => {
        getPrice()
      }, 30000)
      return () => {
        clearInterval(priceIntervalId)
      }
    }
  }, [])

  const getPrice = () => {
    axios.get(`${API_URL}/service/getGoldPrice`).then((response) => {
      setMesghalPrice(response.data.mesghal)
      setGram18Price(response.data.geram18)
      setRecentPrice(response.data.recent)
      setLoadingPrice(false)
      set_key(_key + 1)
    })
  }

  useEffect(() => {
    //    setCalculated(Math.round((parseFloat(price) / point / 705) * parseFloat(carat)).toString())
    var calc = Math.round(parseFloat(price) / 4.3318)
    calc = Math.ceil(((Math.ceil(calc / 1000) * 1000) / 750) * Number(carat))
    setCalculated(calc.toString())
  }, [price, carat, point])

  const save = () => {
    fee.setFee(calculated)
    _carat.setCarat(carat)
    popupHandle.hide(false)
  }

  return (
    <>
      <Modal
        className='fade'
        dialogClassName='mp-invoice-subdialog'
        show
        animation
        id='kt_modal_menu'
        backdrop={true}
        onHide={() => {
          popupHandle.hide(false)
        }}
      >
        <ModalHeader className='px-5 py-3 bg-gray-200'>
          <h2></h2>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => {
              popupHandle.hide(false)
            }}
          >
            <KTIcon className='fs-3x' iconName='cross' />
          </div>
        </ModalHeader>
        <ModalBody>
          <div className='row'>
            <div className='col-12'>
              <CustomInputs
                label='مظنه یک مثقال طلا (ریال)'
                type='currency'
                stateValue={{
                  value: price,
                  setValue: setPrice,
                }}
                key={_key}
                hint={
                  <>
                    {
                      <div className='d-flex'>
                        <span title='قیمت آنلاین'>
                          {loadingPrice && (
                            <i className='las la-spinner la-spin text-warning fs-5'></i>
                          )}
                          {!loadingPrice && (
                            <>
                              <div
                                className='mt-1 d-flex'
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                  setPrice(mesghalPrice)
                                }}
                              >
                                <div className='mt-1'>
                                  <OnlinePulse />
                                </div>
                                <span className='text-success fs-5'>
                                  {numberWithCommas(mesghalPrice)}{' '}
                                  <span className='fs-7'>ریال</span>
                                </span>
                              </div>
                            </>
                          )}
                        </span>
                      </div>
                    }
                  </>
                }
              />
            </div>
            {/* {isMegaPay && (
              <div className='col-12 my-10 text-primary fw-bolder text-center'>
                مظنه یک مثقال طلا <span className='text-info mx-1'>تقسیم بر</span>{' '}
                <input
                  type='number'
                  value={point}
                  className='w-55px text-center'
                  onChange={(e) => {
                    setPoint(Number(e.target.value))
                  }}
                />{' '}
                <span className='text-info mx-1'>تقسیم بر</span> 705{' '}
                <span className='text-info mx-1'>ضرب در</span> عیار
              </div>
            )} */}
            <div className='col-12 mt-5'>
              <CustomInputs
                label={`ضریب تبدیل قیمت مثقال به گرم`}
                type='number'
                stateValue={{
                  value: point,
                  setValue: setPoint,
                }}
              />
            </div>
            <div className='col-12 mt-5'>
              <CustomInputs
                label={`عیار`}
                type='number'
                max={3}
                stateValue={{
                  value: carat,
                  setValue: setCarat,
                }}
              />
            </div>
            <div className='col-12 mt-5'>
              <CustomInputs
                label={`قیمت یک گرم طلا (${carat})`}
                type='currency'
                stateValue={{
                  value: calculated,
                  setValue: setCalculated,
                }}
                key={_key}
                hint={
                  <>
                    {
                      <div className='d-flex'>
                        <span title='قیمت آنلاین'>
                          {loadingPrice && (
                            <i className='las la-spinner la-spin text-warning fs-5'></i>
                          )}
                          {!loadingPrice && (
                            <>
                              <div
                                className='mt-1 d-flex'
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                  setCalculated(gram18Price)
                                }}
                              >
                                <div className='mt-1'>
                                  <OnlinePulse />
                                </div>
                                <span className='text-success fs-5'>
                                  {numberWithCommas(gram18Price)} <span className='fs-7'>ریال</span>
                                </span>
                              </div>
                            </>
                          )}
                        </span>
                      </div>
                    }
                  </>
                }
              />
            </div>
            <div className='col-12 mt-5 text-end'>
              <button className='btn btn-success' onClick={save}>
                درج قیمت
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {GoldPriceCal}
